import { Injectable } from '@angular/core';
import {
    StaffJobList,
    StaffPlanJob,
    StaffPlanJobListEvent,
} from './staff-plan.types';
import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'app/core/services/user.service';
import { SharedService } from 'app/core/services/shared.service';
import { PermissionService } from 'app/core/services/permission.service';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class StaffPlanService {
    jobListEvent: StaffPlanJobListEvent[];
    eventReplySubmitted = new Subject<StaffJobList | null>();
    startDate: Date | null = null;
    endDate: Date | null = null;
    eventFilter = '';
    projectFilter = '';
    teamFilter = '';
    percentFilter = '0';
    trophyFilter = '';
    dataServiceByFilter = '';
    scrollPosition = 'event_0_0_0';
    constructor(
        private translocoService: TranslocoService,
        private httpClient: HttpClient,
        private userService: UserService,
        private sharedService: SharedService,
        private permissionService: PermissionService
    ) {}

    resetFilter() {
        this.startDate = null;
        this.endDate = null;
        this.setStartAndEndDate();
        this.eventFilter = '';
        this.projectFilter = '';
        this.teamFilter = '';
        this.percentFilter = '0';
        this.trophyFilter = '';
        this.dataServiceByFilter = '';
        this.scrollPosition = 'event_0_0_0';
    }

    setStartAndEndDate() {
        if (this.startDate === null) {
            this.startDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 14);
        }
        if (this.endDate === null) {
            this.endDate = new Date(new Date().getFullYear(), 11, 31);
            const start = moment(this.startDate);
            const end = moment(this.endDate);
            if (end.diff(start, 'days') < 167) {
                this.endDate = new Date(this.startDate);
                this.endDate.setDate(this.endDate.getDate() + 167);
            }
        }
    }

    isValidKey(key: string | null | undefined): boolean {
        return (
            key !== undefined &&
            key !== null &&
            key.trim() !== '' &&
            typeof key === 'string' &&
            !isNaN(+key) &&
            +key > 0
        );
    }

    getJobList(
        jobs: StaffPlanJob[],
        eur_id: string,
        eur_job: string,
        cut: boolean = true
    ): { text: string; cutted: boolean } {
        if (!this.isValidKey(eur_id)) {
            return { text: '', cutted: false };
        }
        let returnValue: string;
        let returnedJobStrings: string[] = [];
        if (jobs && jobs.length) {
            if (this.jobListEvent && this.jobListEvent.length) {
                jobs.forEach(job => {
                    if (job.job_id === '19') {
                        let pushValue = eur_job.split('\n');
                        returnedJobStrings = [];
                        returnedJobStrings.push(
                            this.translocoService.getActiveLang() === 'de'
                                ? (pushValue[0] ?? '')
                                : (pushValue[1] ?? pushValue[0] ?? '')
                        );
                        return;
                    }
                    const jobFind = this.jobListEvent.find(
                        item => item.job_id === job.job_id
                    );
                    if (!jobFind) return;
                    let pushValue =
                        this.translocoService.getActiveLang() === 'de'
                            ? jobFind.job_short_de
                            : jobFind.job_short_en;
                    if (job.euj_trainee == '1') {
                        pushValue = '[' + pushValue + ']';
                    }
                    if (job.euj_main === '1') {
                        returnedJobStrings.unshift(pushValue);
                    } else {
                        returnedJobStrings.push(pushValue);
                    }
                });
            } else {
                returnedJobStrings.push('[ERR]');
            }

            returnValue = returnedJobStrings.join('/');
        } else {
            returnValue = '';
        }
        if (returnValue.length < 7 || !cut) {
            return { text: returnValue, cutted: false };
        } else {
            return { text: returnValue.substring(0, 6), cutted: true };
        }
    }

    async getJobListEvent() {
        const formData = new FormData();
        formData.append('json_option', 'job_list_event');

        try {
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/navigator.php?page=pages/event/Staff_plan.php&uid=${this.userService.user.uid}&page_type=json`,
                    formData,
                    {
                        observe: 'response',
                    }
                )
            );
            this.jobListEvent = JSON.parse(JSON.stringify(data.body.result));
        } catch (error) {
            if (error?.error?.result === 'insufficient rights') {
                console.log(
                    'insufficient rights Staff plan - lists (job_list_event)'
                );
            } else {
                console.log(error);
                this.sharedService.showDataNotLoaded(
                    error,
                    'StaffPlanService',
                    'getJobListEvent'
                );
            }
            this.jobListEvent = [];
        }
    }

    isValidIndex(key: string): boolean {
        return (
            key !== null &&
            key.trim() !== '' &&
            typeof key === 'string' &&
            !isNaN(+key) &&
            Number.isInteger(+key) &&
            +key >= 0
        );
    }

    hasPrivilegeAdminOwnEvents(create_user: string = '-1') {
        let success = false;

        if (create_user === '-1' || create_user === this.userService.user.id) {
            success = this.permissionService.hasPermissions([
                'staff_planning_admin_own_events',
            ]);
        }

        return success;
    }
}
